<template>
    <modal @close="close" dialog="modal-lg" class="reservation-modal payment dark-top" :footer="false">
        <div slot="title">
            <h2>Manage Locations</h2>
            <h3>Create the list of locations where you usually transport clients.</h3>
        </div>

        <div slot="body" class="bg-lighter">
            <div class="d-flex h-80">
                <div class="col-sm-4 d-flex flex-column justify-content-between border-right-medium">
                    <div class="w-100 bg-lighter">
                            <button type="button" class="btn cancel widest bg-color-1 lightest w-100" @click="addNewLocation"><i class="ico ico-add"></i>New location</button>
                        </div>

                    <div class="text-center dark my-3" v-if="locationsList.length == 0">No locations to list</div>

                    <div class="row flex-column h-100" v-else>

                        <ul class="scrollMe w-100">
                            <li v-for="location in locationsList" @click="selectLocationToEdit(location)" class="locationRow pointer d-flex justify-content-between px-2 py-1" :class="{'font-weight-600 underlined': location.selected}">
                                <span>
                                    {{location.name}}
                                    <!-- <span v-if="location.selected" class="ml-2 fs-small">(selected)</span> -->
                                </span>
                                <span><i class="ico ico-delete fs-normal" @click="askeToDeleteLocation(location)"></i></span>
                            </li>
                        </ul>
                    </div>

                </div>

                <div class="col-sm-8 p-4">
                    <div class="row">

                        <div class="col-sm-12 mb-2">
                            <label>Name</label>
                            <input type="text" class="w-100" v-model="selectedLocation.name">
                        </div>

                        <div class="col-sm-12 mb-2">
                            <label class="w-100">GPS Coordinates</label>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="w-100">Lat</label>
                                    <input type="text" v-model="selectedLocation.latitude">
                                </div>
                                <div class="col-sm-6">
                                    <label class="w-100">Long</label>
                                    <input type="text" v-model="selectedLocation.longitude">
                                </div>
                            </div>
                        </div>

                        <!-- <div class="col-sm-6">
                            <label class="w-100">Picture</label>
                            <div class="fotoHolder">
                            </div>
                        </div> -->

                        <div class="col-sm-12 mb-2">
                            <label>Notes</label>
                            <textarea v-model="selectedLocation.notes"></textarea>
                        </div>

                        <div class="col-sm-12 d-flex mt-4 justify-content-end">
                            <button class="btn" @click="saveLocation">{{isSaving? 'Saving':'Save Location'}}</button>
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <div slot="footer">
            <button type="button" class="btn cancel widest" @click="cancel">Cancel</button>
            <button type="button" class="btn ok widest" @click="save">Ok</button>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Modal from './Modal'
    import extendedVSelect from '@/extends/vue-select'
    import {eventHub} from '../../main'

    export default {
        data: function () {
            return {
                isSaving: false,
                selectedLocation: {
                	name: null,
                	address: null,
                	latitude: null,
                	longitude: null,
                	notes: null,
                	imagePhoto: null,
                	imagePhotoBase64: null,
                	locationType: 0
                }
            }
        },
        created: function() {
            //get locations
            this.downloadLocations()
        },
        computed: {
            ...mapGetters([
                'account',
                'getAllLocations'
            ]),
            locationsList: function () {
                return this.getAllLocations? this.getAllLocations : []
            },
        },
        methods: {
            ...mapActions([
                'closeModal',
                'createLocation',
                'editLocation',
                'deleteLocation',
                'downloadLocations',
                'addTransportLocation',
                'removeTransportLocation'
            ]),
            cancel: function() {
                this.close();
            },
            close: function() {
                eventHub.$emit('updateTransportLocations');
                this.closeModal();
            },
            save: function() {
                console.log('save');
                this.sendToCreateLocation();
            },
            askeToDeleteLocation: function(location) {
                let vm = this
                this.$dialog.confirm('Delete location called: '+location.name+'?', {okText: 'Yes'})
                .then(function () {
                    vm.deleteThisLocation(location)
                })
                .catch(function () {
                });
            },
            selectLocationToEdit: function(location) {
                this.deselectAllLocations()
                this.$set(location, 'selected', true)
                this.selectedLocation = location
            },
            deselectAllLocations: function () {
                this.locationsList.map(location => {
                    location.selected = false
                })
            },
            saveLocation: function() {
                if(!this.isSaving && this.selectedLocation.name != null){
                this.isSaving = true
                    if(this.selectedLocation.id == null) {
                        this.createLocation(this.selectedLocation).then(response => {
                            this.isSaving = false
                            if(response.status == 200 && response.data.data.id){
                                this.$toasted.success(response.data.message)
                                this.addTransportLocation(response.data.data)
                                this.selectLocationToEdit(response.data.data)
                            }
                        })
                    } else {
                        this.editLocation(this.selectedLocation).then(response => {
                            this.isSaving = false
                            if(response.status == 200 && response.data.data.id){
                                this.$toasted.success(response.data.message)
                            }
                        })
                    }
                }
            },
            deleteThisLocation: function(location) {
                this.deleteLocation(location).then(response => {
                    console.log(response);
                    if(response.status == 200){
                        this.$toasted.success(response.data.message)
                        this.removeTransportLocation(location)
                        this.clearSeletedLocation()
                    }
                })
            },
            clearSeletedLocation: function(){
                this.selectedLocation = {
                	name: null,
                	address: null,
                	latitude: null,
                	longitude: null,
                	notes: null,
                	imagePhoto: null,
                	imagePhotoBase64: null,
                	locationType: 0
                }
            },
            addNewLocation: function(){
                this.deselectAllLocations()
                this.selectedLocation = {
                	name: "New Location (edit me)",
                	address: null,
                	latitude: null,
                	longitude: null,
                	notes: null,
                	imagePhoto: null,
                	imagePhotoBase64: null,
                	locationType: 0
                }
            }

        },
        components: {
            Modal,
            vSelect: extendedVSelect,
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    ul{
        li{
            background-color: $lighter;

            &:nth-child(odd){
                background-color: $lightest;
            }
        }
    }

    .fotoHolder{
        width: 100%;
        height: 200px;
        background: $dark;
    }

    .locationRow{
        i{display: none}
    }

    .locationRow:hover{
        i{display: block;}
    }

    .scrollMe{
        overflow: auto;
        flex: 1;
    }

</style>



// WEBPACK FOOTER //
// TransportManageLocations.vue?cd5ed09c